import ReactEcharts from 'echarts-for-react'

import { BasicTable, ContentCard } from '@/components/customComponents'
import { pieChartOptions } from '@/constants/CHART_CONSTANTS'

interface PaymentTypeTabProps {
  itemName: string
}

const MOCK_PAYMENT_TYPE_DATA = [
  {
    category: 'Online Pick-up',
    percentageOfShare: 25,
    notes: 'App & web orders',
  },
  {
    category: 'In-Store',
    percentageOfShare: 50,
    notes: 'Walk-in Customers',
  },
  {
    category: 'Delivery',
    percentageOfShare: 15,
    notes: 'Aggregators',
  },
  {
    category: 'Cash',
    percentageOfShare: 10,
    notes: 'Mostly in-store',
  },
]

export const PaymentTypeTab = ({ itemName }: PaymentTypeTabProps) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <ContentCard
          title="Payment Method Distribution"
          showViewMore={false}
          onViewMore={() => {}}
          loading={false}
          isBeta
        >
          {true && (
            <ReactEcharts
              option={getPieChartData(
                {
                  'Online Pick-up': 40,
                  'In-Store': 75,
                  Delivery: 15,
                },
                ['Online Pick-up', 'In-Store', 'Delivery']
              )}
            />
          )}
        </ContentCard>
        <ContentCard
          title="Cash vs Credit Card"
          showViewMore={false}
          onViewMore={() => {}}
          loading={false}
          isBeta
        >
          {true && (
            <ReactEcharts
              option={getPieChartData(
                {
                  Cash: 30,
                  'Credit Card': 80,
                },
                ['Cash', 'Credit Card']
              )}
            />
          )}
        </ContentCard>
        <ContentCard
          title="Drive-Thru vs In-Store"
          showViewMore={false}
          onViewMore={() => {}}
          loading={false}
          isBeta
        >
          {true && (
            <ReactEcharts
              option={getPieChartData(
                {
                  'Drive-Thru': 100,
                  'In-Store': 50,
                },
                ['Drive-Thru', 'In-Store']
              )}
            />
          )}
        </ContentCard>
      </div>
      <div>
        <BasicTable
          title="Payment Type Overview"
          data={MOCK_PAYMENT_TYPE_DATA}
          columns={[
            {
              header: 'Category',
              accessorKey: 'category',
              type: 'text',
            },
            {
              header: '% Share',
              accessorKey: 'percentageOfShare',
              type: 'percentage',
            },
            {
              header: 'Notes',
              accessorKey: 'notes',
              type: 'text',
            },
          ]}
          loading={false}
          enablePagination
          itemsPerPage={5}
          isBeta
        />
      </div>
    </div>
  )
}

const getPieChartData = (dataObj: Record<string, number>, labels: string[]) => {
  const data = labels.map((label) => dataObj[label] ?? 0)
  return pieChartOptions(data, labels)
}
